import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";
import ViewOnePageHeading from "../components/ui/heading/ViewOne";

interface ViewLayout {
    title: string;
    description: string;
    icon: LucideIcon;
    buttons: ReactNode;
    children: ReactNode;
}

export default function ViewLayout({
    children,
    title,
    description,
    icon,
    buttons,
}: ViewLayout) {
    return (
        <Card className="min-h-[90vh] rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
            <ViewOnePageHeading
                title={title}
                description={description}
                Icon={icon}
                buttons={buttons}
            />
            <CardContent className="pt-6">{children}</CardContent>
        </Card>
    );
}
